var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wxScan"},[_c('img',{attrs:{"src":("/activity/api.php?m=public&subm=qrcode&url=" + (encodeURIComponent(_vm.URL))),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("活动需在微信操作，请用微信识别此二维码打开活动")]),_vm._v(" "),(_vm.isClient)?_c('div',{staticClass:"btn",on:{"click":_vm.btnClose}},[_vm._v("确定")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5860c663","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/wxScan.vue
// module id = null
// module chunks = 